module.exports = __webpack_public_path__ + "static/media/catering-white.e762fd47.svg";